module.exports = __webpack_public_path__ + "img/device.ab42d1d5.svg";